import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { BASE_URL } from '../../config';

const StyledImg = styled.img`
  cursor: pointer;
  display: flex;
  ${props => css`
    height: ${props.height};
  `};
`;

const getImgName = props => (props.showGreyLogo ? 'solv-grey' : 'solv_dark');

const getImagePath = props => `/images/logo/${getImgName(props)}.svg`;

const Logo = props => {
  const { className, handleLogoOnClick, height } = props;

  return (
    <Fragment>
      {handleLogoOnClick ? (
        <div className={className} onClick={handleLogoOnClick}>
          <StyledImg src={getImagePath(props)} height={height} alt="Solv" />
        </div>
      ) : (
        <a href={BASE_URL} className={className}>
          <StyledImg src={getImagePath(props)} height={height} alt="Solv" />
        </a>
      )}
    </Fragment>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  handleLogoOnClick: PropTypes.func,
  style: PropTypes.object,
  showGreyLogo: PropTypes.bool,
};

Logo.defaultProps = {
  height: 16,
  style: {},
};

export default Logo;
